<template>
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="88px"
    >
      <el-form-item label="昵称" prop="nickname">
        <el-input
          v-model="queryParams.nickname"
          class="!w-160px"
          clearable
          placeholder="会员昵称"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="手机号" prop="mobile">
        <el-input
          v-model="queryParams.mobile"
          class="!w-160px"
          clearable
          placeholder="手机号"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="订单号" prop="orderNo">
        <el-input
          v-model="queryParams.orderNo"
          class="!w-180px"
          clearable
          placeholder="商城订单号"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="商品" prop="spuName">
        <el-input
          v-model="queryParams.spuName"
          class="!w-160px"
          clearable
          placeholder="商品名"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="queryParams.status" class="!w-130px" clearable placeholder="全部">
          <el-option
            v-for="o in STATUS_OPTS"
            :key="o.value"
            :label="o.label"
            :value="o.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="人工暂停" prop="adminPaused">
        <el-select v-model="queryParams.adminPaused" class="!w-110px" clearable placeholder="全部">
          <el-option :value="true" label="是" />
          <el-option :value="false" label="否" />
        </el-select>
      </el-form-item>
      <el-form-item label="售后暂停" prop="afterSalePaused">
        <el-select
          v-model="queryParams.afterSalePaused"
          class="!w-110px"
          clearable
          placeholder="全部"
        >
          <el-option :value="true" label="是" />
          <el-option :value="false" label="否" />
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间" prop="createTime">
        <el-date-picker
          v-model="queryParams.createTime"
          class="!w-240px"
          end-placeholder="结束"
          start-placeholder="开始"
          type="daterange"
          value-format="YYYY-MM-DD HH:mm:ss"
          :default-time="[new Date('1 00:00:00'), new Date('1 23:59:59')]"
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery"><Icon class="mr-5px" icon="ep:search" />搜索</el-button>
        <el-button @click="resetQuery"><Icon class="mr-5px" icon="ep:refresh" />重置</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list" :stripe="true" :show-overflow-tooltip="true">
      <el-table-column align="center" label="编号" prop="id" width="70" />
      <el-table-column align="center" label="会员" min-width="140">
        <template #default="{ row }">
          <div class="flex items-center justify-center gap-8px">
            <el-avatar :src="row.avatar" :size="28" />
            <div class="text-left">
              <div>{{ row.nickname || '-' }}</div>
              <div class="text-xs text-gray-400">{{ row.mobile || row.userId }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="订单号" prop="orderNo" min-width="150" />
      <el-table-column align="center" label="商品" prop="spuName" min-width="120" />
      <el-table-column align="center" label="件序号" width="80">
        <template #default="{ row }">
          {{ row.pieceIndex }}{{ row.pieceCount ? '/' + row.pieceCount : '' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="总额" width="90">
        <template #default="{ row }">￥{{ fenToYuan(row.totalPrice || 0) }}</template>
      </el-table-column>
      <el-table-column align="center" label="日额" width="80">
        <template #default="{ row }">￥{{ fenToYuan(row.dailyPrice || 0) }}</template>
      </el-table-column>
      <el-table-column align="center" label="比例" width="80">
        <template #default="{ row }">{{ formatRate(row.dailyRate) }}</template>
      </el-table-column>
      <el-table-column align="center" label="已发/剩余" min-width="110">
        <template #default="{ row }">
          ￥{{ fenToYuan(row.grantedPrice || 0) }} / ￥{{ fenToYuan(row.remainPrice || 0) }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" width="90">
        <template #default="{ row }">
          <el-tag :type="statusTag(row.status)" size="small">{{ statusLabel(row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="暂停标记" width="120">
        <template #default="{ row }">
          <el-tag v-if="row.adminPaused" class="mr-4px" size="small" type="warning">人工</el-tag>
          <el-tag v-if="row.afterSalePaused" size="small" type="danger">售后</el-tag>
          <span v-if="!row.adminPaused && !row.afterSalePaused">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="首次可发日" prop="firstGrantDate" width="110" />
      <el-table-column align="center" label="最近发放" prop="lastGrantDate" width="110" />
      <el-table-column
        align="center"
        label="创建时间"
        prop="createTime"
        :formatter="dateFormatter"
        width="170"
      />
      <el-table-column align="center" fixed="right" label="操作" width="220">
        <template #default="{ row }">
          <el-button
            v-hasPermi="['distribution:cashback:plan:query']"
            link
            type="primary"
            @click="openDetail(row.id)"
          >
            详情
          </el-button>
          <el-button
            v-if="row.canPause"
            v-hasPermi="['distribution:cashback:plan:pause']"
            link
            type="warning"
            @click="handleOp('pause', row)"
          >
            暂停
          </el-button>
          <el-button
            v-if="row.canResume"
            v-hasPermi="['distribution:cashback:plan:resume']"
            link
            type="success"
            @click="handleOp('resume', row)"
          >
            恢复
          </el-button>
          <el-button
            v-if="row.canVoid"
            v-hasPermi="['distribution:cashback:plan:void']"
            link
            type="danger"
            @click="handleOp('void', row)"
          >
            作废
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <PlanDetail ref="detailRef" />
</template>

<script lang="ts" setup>
import { fenToYuan } from '@/utils'
import { dateFormatter } from '@/utils/formatTime'
import * as CashbackPlanApi from '@/api/mall/trade/cashback/plan'
import type { CashbackPlanVO } from '@/api/mall/trade/cashback/plan'
import PlanDetail from './PlanDetail.vue'

defineOptions({ name: 'TradeCashbackPlan' })

const message = useMessage()

const STATUS_OPTS = [
  { value: 1, label: '发放中', type: 'primary' },
  { value: 2, label: '已完成', type: 'success' },
  { value: 3, label: '已关闭', type: 'info' },
  { value: 4, label: '已作废', type: 'danger' }
]

const statusLabel = (s?: number) => STATUS_OPTS.find((o) => o.value === s)?.label || '-'
const statusTag = (s?: number) => (STATUS_OPTS.find((o) => o.value === s)?.type as any) || 'info'
const formatRate = (r?: number) => (r == null ? '-' : (r / 100).toFixed(2) + '%')

const loading = ref(false)
const list = ref<CashbackPlanVO[]>([])
const total = ref(0)
const queryFormRef = ref()
const detailRef = ref<InstanceType<typeof PlanDetail>>()
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  nickname: undefined as string | undefined,
  mobile: undefined as string | undefined,
  orderNo: undefined as string | undefined,
  spuName: undefined as string | undefined,
  status: undefined as number | undefined,
  adminPaused: undefined as boolean | undefined,
  afterSalePaused: undefined as boolean | undefined,
  createTime: undefined as string[] | undefined
})

const getList = async () => {
  loading.value = true
  try {
    const data = await CashbackPlanApi.getCashbackPlanPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}
const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}
const resetQuery = () => {
  queryFormRef.value?.resetFields()
  handleQuery()
}
const openDetail = (id: number) => detailRef.value?.open(id)

const handleOp = async (type: 'pause' | 'resume' | 'void', row: CashbackPlanVO) => {
  const titles = {
    pause: '暂停发放（期间不发、恢复后不补发）',
    resume: '恢复发放（下一业务日继续，不补欠天）',
    void: '作废计划（已发不追回、未发不再发，不可恢复）'
  }
  try {
    const { value } = await ElMessageBox.prompt('请填写操作备注（必填）', titles[type], {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPattern: /\S+/,
      inputErrorMessage: '备注不能为空',
      type: type === 'void' ? 'warning' : 'info'
    })
    if (type === 'pause') {
      await CashbackPlanApi.pauseCashbackPlan({ id: row.id!, reason: value })
    } else if (type === 'resume') {
      await CashbackPlanApi.resumeCashbackPlan({ id: row.id!, reason: value })
    } else {
      await CashbackPlanApi.voidCashbackPlan({ id: row.id!, reason: value })
    }
    message.success('操作成功')
    await getList()
  } catch {
    /* cancel */
  }
}

onMounted(getList)
</script>
